// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"styles_aboutContainer__3bLNK","content":"styles_content__hurzT","paragraphContainer":"styles_paragraphContainer__3kJjL","aboutImage":"styles_aboutImage__2fPBW"};